import { render, staticRenderFns } from "./BiometricDashboard.vue?vue&type=template&id=6dd20ea6&scoped=true&"
import script from "./BiometricDashboard.vue?vue&type=script&lang=js&"
export * from "./BiometricDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BiometricDashboard.vue?vue&type=style&index=0&id=6dd20ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd20ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow,VSelect,VSkeletonLoader,VSnackbar})
